import {useMenu} from "./hooks/useMenu";
import {getPreferredFontColorByBackgroundColor} from "../../../../../../../studio/utils/color";
import MulticoloredCircle from "./MulticoloredCircle";


export default function ({dataToRender, figuresToShowTransparencies, category}) {
    const {shouldShowCooRanges, figuresToShow, shouldMakeRareObjectsTranslucent} = useMenu();
    // console.log(dataToRender);
    // console.log(figuresToShowTransparencies);

    let figureNames = Object.keys(dataToRender);
    let filteredDataToRender = {};
    for (let i = 0; i < figureNames.length; i++) {
        let figureName = figureNames[i];
        if (dataToRender[figureName].type === 'point') {
            filteredDataToRender[figureName] = dataToRender[figureName];
        }
    }

    return Object.keys(filteredDataToRender).map(settlement => {
        const settlementObject = filteredDataToRender[settlement];
        const transparency = shouldMakeRareObjectsTranslucent ? figuresToShowTransparencies[settlement] : "";

        return figuresToShow[category].indexOf(settlement) !== -1 ? <g>
            {shouldShowCooRanges && <rect
                x={settlementObject.minX}
                y={settlementObject.minY}
                width={settlementObject.maxX - settlementObject.minX}
                height={settlementObject.maxY - settlementObject.minY}
                fill={`${settlementObject.color}10`}
                stroke="none"
            />}
            <text
                fill={`${settlementObject.fontColor}${transparency}`}
                x={(settlementObject.x + settlementObject.volume) + 2}
                y={settlementObject.y + settlementObject.volume / 2 + settlementObject.fontSize * 0.7}
                fontSize={settlementObject.fontSize * 2}
            >{`${settlement} (${settlementObject.orderIndex})`}</text>
            {
                // category === "Населенные пункты" ?
                <>
                    {/*<circle*/}
                    {/*    r={settlementObject.volume / 2}*/}
                    {/*    cx={(settlementObject.x)}*/}
                    {/*    cy={(settlementObject.y)}*/}
                    {/*    fill={`${settlementObject.color}${transparency}`}*/}
                    {/*    stroke={`#000000${transparency}`}*/}
                    {/*/>*/}
                    <MulticoloredCircle
                        r={settlementObject.volume}
                        x={settlementObject.x + settlementObject.volume / 2}
                        y={settlementObject.y + settlementObject.volume / 2}
                        colorDistribution={settlementObject.sourceColor}
                        transparency={transparency}
                    />
                </>
                // :
                // <rect
                //     width={settlementObject.volume}
                //     height={settlementObject.volume}
                //     x={settlementObject.x}
                //     y={settlementObject.y}
                //     fill={`${settlementObject.color}${transparency}`}
                //     stroke={`#000000${transparency}`}
                // />
            }
            <text
                fill={getPreferredFontColorByBackgroundColor(settlementObject.fontColor)}
                x={settlementObject.x}
                y={settlementObject.y + settlementObject.volume * 0.5 - 2}
                fontSize={settlementObject.volume / 2}
            >{Math.round(settlementObject.frequency * 100) + "%"}</text>
        </g> : null
    });
}
